export enum LocalStorageKeys {
    BOT_ID = 'botID|',
    SESSION = 'sessionID|',
    VERSION = 'VERSION',
}
